import { useSelector } from "react-redux";
import * as CONST from "./actionTypes";

const intialState = {
  isLogin: false,
  loading: false,
  user: [],
  userEmail: (localStorage && localStorage.getItem("email")) || null,
  token: (localStorage && localStorage.getItem("token")) || null,
  userName: (localStorage && localStorage.getItem("name")) || null,
  error: null,
};

const LoginReducer = (state = intialState, { type, payload }) => {
  switch (type) {
    case CONST.LOGIN_USER:
      return {
        ...state,
        isLogin: true,
        loading: true,

        error: null,
      };
    case CONST.LOGIN_USER_SUCCESS:
      return {
        ...state,
        loading: true,
        token: payload.token,
        user: payload,
        error: null,
      };
    case CONST.LOGIN_USER_FAIL:
      return {
        ...state,
        loading: false,

        error: payload,
      };

    // verify otp

    case CONST.VERIFY_OTP:
      return {
        ...state,
        isLogin: true,
        loading: true,
        error: null,
      };
    case CONST.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        loading: true,
        token: payload.token,
        user: payload,
        error: null,
      };
    case CONST.VERIFY_OTP_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    // CREATE PASS SUBADMIN

    case CONST.CREATE_PASS_SUBADMIN:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CONST.CREATE_PASS_SUBADMIN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case CONST.CREATE_PASS_SUBADMIN_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    // SELECT OTP OPTION

    case CONST.SELECT_OTP_OPTION:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case CONST.SELECT_OTP_OPTION_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
      };
    case CONST.SELECT_OTP_OPTION_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;

      break;
  }
};

export default LoginReducer;
